import Feedback from './Feedback';

export const FeedBackComp = Feedback;
